import React, { FC, useCallback } from "react";
import { useQuery } from "react-query";

import { fetchFeatureFlags, FEATURE_FLAG } from "@/data/feature-flags";

import { FeatureFlagsContextProvider } from "./context";

export const FeatureFlagsProvider: FC = ({ children }) => {
  const { data: featureFlags } = useQuery("feature-flags", () => fetchFeatureFlags(), { suspense: true });

  const isFeatureEnabled = useCallback(
    (featureFlag: FEATURE_FLAG) => featureFlags?.includes(featureFlag) ?? false,
    [featureFlags],
  );

  const isFeatureDisabled = useCallback(
    (featureFlag: FEATURE_FLAG) => !featureFlags?.includes(featureFlag),
    [featureFlags],
  );

  return (
    <FeatureFlagsContextProvider
      value={{
        featureFlags,
        isFeatureEnabled,
        isFeatureDisabled,
      }}>
      {children}
    </FeatureFlagsContextProvider>
  );
};
